export default __webpack_public_path__ + "static/media/pictogramAlert40.76d42d1e.svg";